import React from 'react'
import { Button } from '../../ui'

export function TasksPageHeader({
  openCount,
  overdueCount,
  onCreateClicked,
  filtersOpen = false,
  filterActiveCount = 0,
  filtersPanelId,
  onToggleFilters,
}) {
  return (
    <div style={styles.header}>
      <div style={styles.topRow}>
        <h1 style={styles.title}>Tasks</h1>
        <div style={styles.actions}>
          {onToggleFilters && (
            <Button
              variant="secondary"
              active={filterActiveCount > 0}
              count={filterActiveCount > 0 ? filterActiveCount : undefined}
              aria-expanded={filtersOpen}
              aria-controls={filtersPanelId}
              onClick={onToggleFilters}
            >
              Filters
            </Button>
          )}
          {onCreateClicked && (
            <Button variant="secondary" onClick={onCreateClicked} aria-label="New task">
              + New task
            </Button>
          )}
        </div>
      </div>
      <div style={styles.summary}>
        <span>{openCount} open task{openCount === 1 ? '' : 's'}</span>
        {overdueCount > 0 && (
          <span style={styles.overdue}> · {overdueCount} overdue</span>
        )}
      </div>
    </div>
  )
}

const styles = {
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    paddingBottom: 12,
    borderBottom: '1px solid var(--border)',
  },
  topRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    margin: 0,
    color: 'var(--text-primary)',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  summary: {
    fontSize: 13,
    color: 'var(--text-secondary)',
  },
  overdue: {
    color: 'var(--danger-text)',
    fontWeight: 600,
  },
}
